<template>
  <div class="message">Loading...</div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
.message {
  margin: 1.5rem 0;
}
</style>
